import { formatDate } from "../../helpers/dateFormatters";
import statics from "@/statics";
import api from "@/api";
import moment from "moment";

export default {
  state: {
    formModels: [],
    singletonFormModels: [],
    singleModel: {
      id: "",
      policy_number: "",
      branch_category_id: "",
      policy_status_id: "",
      policy_statusHasError: false,
      serviceId: "",
      submit_date: null,
      submit_dateHasError: false,
      startDate: "",
      endDate: formatDate(statics.lastDateOfCurrentYear),
      franchise: "",
      accident: "",
      doctorName: "",
      price: "",
      interval: "",
      plateNumber: "",
      startDateHasError: false,
      priceHasError: false,
    },
    models: [],
  },
  getters: {
    formModels: (state) => state.formModels,
    singleModel: (state) => state.singleModel,
    singletonFormModels: (state) => state.singletonFormModels,
    models: (state) => state.models,
  },
  mutations: {
    setFormModels: (state, data) => {
      state.formModels = data;
    },
    setSingleModel: (state, data) => {
      state.singleModel = data;
    }, 
    setSpecificFormModel: (state, { index, key, data }) => {
      const currentModel = state.formModels[index];
      if (!currentModel) return;

      const branchId = currentModel.branch_category_id;
      const sharedFields = ["policy_number", "policy_status_id", "submit_date"];

      // 1. Update Validation for the target model
      if (key === "startDate") currentModel.startDateHasError = !data;
      if (key === "endDate") currentModel.startDateHasError = moment(currentModel.startDate).isAfter(moment(data));
      if (key === "price") {
        currentModel.priceHasError = (!data || data < 0 || statics.stringRegex.test(data) || statics.symbolRegex.test(data));
      }

      // 2. Apply change to the target model
      currentModel[key] = data;

      // 3. Branch Synchronization
      if (sharedFields.includes(key)) {
        const allArrays = [state.formModels, state.singletonFormModels];
        if (state.singleModel) allArrays.push([state.singleModel]);

        allArrays.forEach(array => {
          array.forEach(model => {
            if (model.branch_category_id === branchId) {
              model[key] = data;

              // Sync validation flags so the 'Save' button stays responsive
              if (key === "policy_status_id") {
                model.policy_statusHasError = !data;
                if (data !== 1) {
                  model.submit_date = null;
                  model.submit_dateHasError = false;
                }
              }
              if (key === "submit_date") {
                model.submit_dateHasError = (model.policy_status_id === 1 && !data);
              }
            }
          });
        });
      }
    }, 
    setSpecificSingleModel: (state, { key, data }) => {
      if (!state.singleModel) return;

      const branchId = state.singleModel.branch_category_id;
      const sharedFields = ["policy_number", "policy_status_id", "submit_date"];

      // 1. Update Validation for the Single Model
      if (key === "startDate") {
        state.singleModel.startDateHasError = !data;
        if (data) state.singleModel.endDate = formatDate(moment(data).endOf("year"));
      }
      if (key === "price") {
        state.singleModel.priceHasError = (!data || data < 0 || statics.stringRegex.test(data) || statics.symbolRegex.test(data));
      }

      // 2. Apply change to Single Model
      state.singleModel[key] = data;

      // 3. Branch Synchronization (KVG -> VVG/Singletons)
      if (sharedFields.includes(key)) {
        const allArrays = [state.formModels, state.singletonFormModels];

        allArrays.forEach(array => {
          array.forEach(model => {
            if (model.branch_category_id === branchId) {
              model[key] = data;

              if (key === "policy_status_id") {
                model.policy_statusHasError = !data;
                if (data !== 1) {
                  model.submit_date = null;
                  model.submit_dateHasError = false;
                }
              }
              if (key === "submit_date") {
                model.submit_dateHasError = (model.policy_status_id === 1 && !data);
              }
            }
          });
        });

        // Handle internal SingleModel status logic
        if (key === "policy_status_id") {
          state.singleModel.policy_statusHasError = !data;
          if (data !== 1) {
            state.singleModel.submit_date = null;
            state.singleModel.submit_dateHasError = false;
          }
        }
        if (key === "submit_date") {
          state.singleModel.submit_dateHasError = (state.singleModel.policy_status_id === 1 && !data);
        }
      }
    }, 
    setSingletonFormModels: (state, data) => {
      state.singletonFormModels = data;
    },
    setSpecificSingletonFormModel: (state, { index, key, data }) => {

      if (!state.singletonFormModels[index]) return;

      if (key === "startDate") {
        if (!data) {
          state.singletonFormModels[index].startDateHasError = true;
        } else {
          state.singletonFormModels[index].startDateHasError = false;
        }
      }

      if (key === "endDate") {
        if (
          moment(state.singletonFormModels[index].startDate).isAfter(
            moment(data)
          )
        ) {
          state.singletonFormModels[index].startDateHasError = true;
        } else {
          state.singletonFormModels[index].startDateHasError = false;
        }
      }

      if (key === "price") {
        if (
          !data ||
          data < 0 ||
          statics.stringRegex.test(data) ||
          statics.symbolRegex.test(data)
        ) {
          state.singletonFormModels[index].priceHasError = true;
        } else {
          state.singletonFormModels[index].priceHasError = false;
        }
      }

      if (key === "policy_status_id") {
        if (!data) {
          state.singletonFormModels[index].policy_statusHasError = true;
        } else {
          state.singletonFormModels[index].policy_statusHasError = false;
        }

        if (data === 1) {
          if (!state.singletonFormModels[index].submit_date) {
            state.singletonFormModels[index].submit_dateHasError = true;
          } else {
            state.singletonFormModels[index].submit_dateHasError = false;
          }
        } else {
          state.singletonFormModels[index].submit_date = null;
          state.singletonFormModels[index].submit_dateHasError = false;

          const branchId =
            state.singletonFormModels[index].branch_category_id;

          state.formModels.forEach((model) => {
            if (model.branch_category_id === branchId) {
              model.submit_date = null;
              model.submit_dateHasError = false;
            }
          });
        }
      }

      if (key === "submit_date") {
        if (
          state.singletonFormModels[index].policy_status_id === 1 &&
          !data
        ) {
          state.singletonFormModels[index].submit_dateHasError = true;
        } else {
          state.singletonFormModels[index].submit_dateHasError = false;
        }
      }

      state.singletonFormModels[index][key] = data;

      if (key === "policy_number" || key === "policy_status_id") {
        const branchId =
          state.singletonFormModels[index].branch_category_id;

        state.singletonFormModels.forEach((model) => {
          if (model.branch_category_id === branchId) {
            model[key] = data;
          }
        });

        state.formModels.forEach((model) => {
          if (model.branch_category_id === branchId) {
            model[key] = data;
          }
        });
      }
    },
    setModels: (state, data) => {
      state.models = data;
    },
  },
  actions: {
    getModelsByCompanyServiceAndCustomer: (
      _,
      { companyId, serviceId, customerId }
    ) => {
      return new Promise((resolve, reject) => {
        api({ requiresAuth: true })
          .get(
            `/v1/companies/${companyId}/services/${serviceId}/customers/${customerId}/models`
          )
          .then(
            (response) => {
              const { data } = response.data;
              resolve(data);
            },
            (error) => {
              console.error(error);
              reject(error);
            }
          );
      });
    },

    getModelsByCompanyAndServices: (_, { companyId, serviceId }) => {
      return new Promise((resolve, reject) => {
        api({ requiresAuth: true })
          .get(`/v1/companies/${companyId}/services/${serviceId}/models`)
          .then(
            (response) => {
              const { data } = response.data;
              resolve(data);
            },
            (error) => {
              console.error(error);
              reject(error);
            }
          );
      });
    },

    deleteModel: async (_, modelId) => {
      try {
        await api({ requiresAuth: true }).delete(
          `/v1/service-models/${modelId}`
        );
      } catch (err) {
        console.error(err);
      }
    },

    updateModel: async (
      { commit },
      { name, modelId, companyId, serviceId }
    ) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/service-models/${modelId}`,
          {
            name,
            company_id: companyId,
            service_id: serviceId,
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: "Model updated successfully.",
        });
      } catch (err) {
        console.error(err);
      }
    },

    addModel: async (
      { commit },
      { companyId, serviceId, name, canton, region, categories }
    ) => {
      try {
        await api({ requiresAuth: true }).post("/v1/service-models", {
          company_id: companyId,
          service_id: serviceId,
          name,
          canton,
          region,
          model_categories: categories,
        });
        commit("setToast", {
          display: true,
          type: "success",
          message: "Model added successfully.",
        });
      } catch (err) {
        console.error(err);
      }
    },
  },
};
